import Vue from 'vue';
import Component from 'vue-class-component';
import { USER_TYPE } from '@/auth/values/auth.values';
import Quill, {Delta} from 'quill';

@Component({})
export class TextMixin extends Vue {

    /**** Computed properties ****/
    get isPresentationMode(): boolean {
        return this.$store.state.CourseStore.isPresentationStudentMode || this.$store.state.CourseStore.isPresentationTeacherMode;
    }

    get sessionUserId(): number {
        return this.$store.state.AuthStore.user.id;
    }

    get sessionUserRole(): string {
        return this.$store.state.AuthStore.user.role;
    }

    get isStudent(): boolean {
        return USER_TYPE.STUDENT === this.sessionUserRole;
    }

    get isPresentationModeGuestTeacher(): boolean {
        return this.$store.state.MeetingsStore.isPresentationModeGuestTeacher;
    }

    get isPresentationModeMainTeacher(): boolean {
        return this.$store.state.CourseStore.isPresentationTeacherMode;
    }

    get currentBoardUser(): any {
        return this.$store.state.MeetingsStore.currentBoardUser;
    }

    get currentBoardUserId(): number {
        return this.currentBoardUser?.id;
    }

    get isCurrentBoardUserActive(): boolean {
        return (this.isCurrentBoardUserTeacher || (this.isCurrentBoardUserStudent && this.currentBoardUser?.active));
    }

    get amICurrentBoardUser(): boolean {
        return this.currentBoardUserId && this.currentBoardUserId == this.sessionUserId;
    }

    get isCurrentBoardUserTeacher(): boolean {
        return (this.currentBoardUserId && this.currentBoardUser.isTeacher)
            || (this.currentBoardUser && Object.keys(this.currentBoardUser).length === 0)
            || !this.currentBoardUser;
    }

    get isCurrentBoardUserStudent(): boolean {
        return this.currentBoardUserId && !this.currentBoardUser.isTeacher;
    }

    protected isReadOnly(): boolean {
        throw new Error('Component must implement method: isReadOnly');
    }

    protected setTextEditorContent(textEditor: Quill, delta: Delta): void {
        textEditor?.setContents(delta);
    }

    protected getTextEditorContent(textEditor: Quill): Delta {
        return textEditor?.getContents();
    }
}
